import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { CssBaseline, Stack, IconButton } from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import ThurentEventForm from "../redesign/components/ThurentEventForm";
import './Eventspage_module.css'
import '../redesign/css/Home.css'
import ProviderServices from "./ProviderServices";
import { homePagePath } from "../constant";
import { fetchAllEventCategoriesWithEvents } from "../Apiservices/Auth/servers/fetchCategoryEvents";
import EventForm from "./eventComponent/EventForm2";
import { Dialog } from "primereact/dialog";
import { useTransition } from "react";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";
import { eventbasedseomapping } from "../redesign/components/Services/seoMappings";

export const Eventspage = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const { slug } = useParams();
  const seoData = eventbasedseomapping.default; 
  const [event, setEvent] = useState();
  const [eventCategories, setEventCategories] = useState([]);

  const [visible, setVisible] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState();

  const [isPending, startTransition] = useTransition();

  const loadEventCategories = async () => {
    startTransition(async () => {
      const response = await fetchAllEventCategoriesWithEvents();
      if (response) {
        setEvent(
          response?.find(
            (event) => event.name?.toLowerCase()?.replaceAll(" ", "-") === slug
          )
        );
        setEventCategories(response);
      }
    });
  };

  useEffect(() => {
    loadEventCategories();
  }, []);

  useEffect(() => {
    setEvent(
      eventCategories?.find(
        (event) => event.name?.toLowerCase()?.replaceAll(" ", "-") === slug
      )
    );
  }, [slug]);

  const backtoHome = () => {
    isLoggedIn ? navigate("/dashboard") : navigate(homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [slug]);
  const renderWithSpacingAndColor = (desc) => {
    if (!desc) return null;
  
    // Split into sentences by '. '
    const sentences = desc.split('. ').filter(Boolean);
  
    // Total words count for coloring
    const words = desc.split(' ');
    const halfway = Math.floor(words.length / 2);
  
    let wordCount = 0;
  
    return (
      <>
        {sentences.map((sentence, idx) => {
          const sentenceWords = sentence.split(' ');
          const firstHalfWords = [];
          const secondHalfWords = [];
  
          sentenceWords.forEach(word => {
            if (wordCount < halfway) firstHalfWords.push(word);
            else secondHalfWords.push(word);
            wordCount++;
          });
  
          // Return multiple lines inside each sentence wrapped by <div> with margin
          return (
            <div key={idx} style={{ marginBottom: '20px' }}>
              {/* Wrap first half words in span */}
              <span>{firstHalfWords.join(' ')}</span>{' '}
              {/* Wrap second half words in colored span */}
              <span style={{ color: '#383838' }}>
                {secondHalfWords.join(' ')}
              </span>
              {idx < sentences.length - 1 && '.'}
            </div>
          );
        })}
      </>
    );
  };
  
  return (
    <div style={{ width: "100%" }}>
      <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
      </Helmet>
      <CssBaseline />
      <Navbar/>
      <div className={`main-container-eventpage ${!isLoggedIn && "no-auth"}`}>
        <div className="frontend-containe-eventspager">
          <div style={{ width: "100%", paddingBottom: "30px" }}>
            {isPending || !event || !eventCategories ? (
              <h3 style={{ textAlign: "center" }}>
                <i
                  className="pi pi-spin pi-spinner-dotted"
                  style={{ fontSize: "2rem", color: "#0cc0df" }}
                ></i>
              </h3>
            ) : (
              <>
                <div className="event-form-inner-eventspage">

                  <div className="event-form-body-events-page list">
                    <div className="event-form-body-inner-eventspage">
                    
                      <div className="event-form-head-eventpage">
                        <div className="event-service-head-inner-eventspage">
                         
                          <div>
                          <h1>
                            <span className="header-black">
                              {event?.name}
                              <br />
                              {renderWithSpacingAndColor(event?.shortDescription)}
                            </span>
                          </h1>



                            <div className="event-rsvp-eventspage">
                              
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: event?.longDescription,
                        }}
                        style={{
                          paddingBottom: "30px",
                        }}
                      ></div>

                      <Dialog
                        visible={visible}
                        onHide={() => setVisible(false)}
                        header={<>Create event for {selectedEvent?.name}</>}
                      >
                        <EventForm
                          preSelectedEvent={selectedEvent}
                          onCloseDailog={() => {
                            setVisible(false);
                            navigate("/dashboard");
                          }}
                        />
                      </Dialog>
                    </div>
                    <div className="event-service-list-eventspage sidebar">
                      <div className="create-event-form-eventpage">
                        <ThurentEventForm />
                      </div>
                    </div>
                  </div>
                </div>
                
                 <div className="event-tabs-wrapper" style={{ background: 'transparent', display: 'block', marginTop: '40px', paddingTop: 0, paddingBottom: 0 }}>
                  <div className="middle-content-service-eventspages" style={{ width: '100%' }}>
                    <div className="th-section__container" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column', marginBottom: '24px', textAlign: 'center' }}>
                      <span className="th-hero__text th-hero__text__title th-hero__text__sub" style={{ display: 'block', textAlign: 'center', width: '100%' }}>
                        {event.name.toLowerCase() === "funeral" ? (
                          <>{event.name} <span className="th-hero__text__subtitle">?</span></>
                        ) : (
                          <>What {event.name} are you{' '}<span className="th-hero__text__subtitle">Celebrating?</span></>
                        )}
                      </span>
                    </div>

                    <div className="th-section__ev__category__container">
                      {event?.events?.map((ev) => (
                        <div
                          key={ev.id}
                          className="th-section__ev__category__item"
                          onClick={() => {
                            setVisible(true);
                            setSelectedEvent(ev);
                          }}
                        >
                          <span className="th-plan__text th-line__height" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>{ev.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                
                 <div className="event-tabs-wrapper" style={{ background: 'transparent', display: 'block', marginTop: '40px', paddingTop: 0, paddingBottom: 0 }}>
                  <div className="Events-service-display" style={{ width: '100%' }}>
                    <div className="th-section__container" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column', marginBottom: '24px', textAlign: 'center' }}>
                      <span className="th-hero__text th-hero__text__title th-hero__text__sub" style={{ display: 'block', textAlign: 'center', width: '100%' }}>
                        Not Sure What Your Event Is?{' '}
                        <span className="th-hero__text__subtitle">Find It Here!</span>
                      </span>
                    </div>
                    <div className="th-section__ev__category__container">
                      {eventCategories.length > 0 &&
                        eventCategories
                          .filter((item) => item.id !== event?.id)
                          .map((item) => (
                            <Link
                              key={item.id}
                              className="th-section__ev__category__item"
                              style={{ textDecoration: 'none' }}
                              to={`/event/${item.name
                                ?.toLowerCase()
                                ?.replaceAll(" ", "-")}`}
                            >
                              <span className="th-plan__text th-line__height" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>{item.name}</span>
                            </Link>
                          ))}
                    </div>
                  </div>
                </div>
                <ProviderServices />
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <ConfirmDialog />
    </div>
  );
};
export default Eventspage;